export const service = `${window.location.protocol}//${window.location.host}/`;

function base64UrlEncode(bytes: Uint8Array): string {
    let binary = "";
    bytes.forEach(b => {
        binary += String.fromCharCode(b);
    });

    return btoa(binary)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/g, "");
}

function randomString(length = 64): string {
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    const random = new Uint8Array(length);
    crypto.getRandomValues(random);
    return Array.from(random, v => alphabet[v % alphabet.length]).join("");
}

export async function generatePkcePair(): Promise<{ codeVerifier: string; codeChallenge: string }> {
    const codeVerifier = randomString(64);
    const data = new TextEncoder().encode(codeVerifier);
    const digest = await crypto.subtle.digest("SHA-256", data);
    const codeChallenge = base64UrlEncode(new Uint8Array(digest));

    return { codeVerifier, codeChallenge };
}

export const redirectUri = `${window.location.protocol}//${window.location.host}/auth/callback`;

export const redirectToSAMLlogin = async () => {
    const state = crypto.randomUUID();
    const { codeVerifier, codeChallenge } = await generatePkcePair();

    localStorage.setItem("lsha_auth_state", state);
    localStorage.setItem("lsha_auth_code_verifier", codeVerifier);

    const loginUrl = new URL(`https://${import.meta.env.VITE_AUTH_HOST}/login.php`);
    loginUrl.searchParams.set("redirect_uri", redirectUri);
    loginUrl.searchParams.set("state", state);
    loginUrl.searchParams.set("code_challenge", codeChallenge);

    window.location.assign(loginUrl.toString());
};

/*
export const logoutUrl = () => {
    return `https://${import.meta.env.VITE_AUTH_HOST}/simplesaml/module.php/core/logout/default-sp`;
};
*/
